import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { DraftContext } from '../../../../../../contexts/DraftContext'
import ActionInfluencerItem from './ActionInfluencerItem'

export default observer(function SidebarList() {
  const { influencers } = useContext(DraftContext)

  return (
    <div>{ influencers.map(inf => <ActionInfluencerItem key={inf.id} influencer={inf} />)}</div>
  )
})
